export default "__VITE_ASSET__DoGG3fL5__"